import type { ReactNode } from 'react'
import React from 'react'
import { HorizontalStack } from '../HorizontalStack'

const BoxBody = ({ children, className = 'py-3' }: { children: ReactNode; className?: string }) => {
  return <div className={className}>{children}</div>
}

const BoxHeader = ({ children, className }: { children: ReactNode; className?: string }) => {
  className = className || 'justify-content-between'
  return <HorizontalStack className={className}>{children}</HorizontalStack>
}

export const Box = ({ children, className = '' }: { children: ReactNode; className?: string }) => {
  return (
    <div className={`  ${className} border`}>
      <div className="p-3">{children}</div>
    </div>
  )
}

Box.Header = BoxHeader
Box.Body = BoxBody
